'use strict';

let secretNumber = Math.trunc(Math.random() * 20) + 1;
let score = 20;
let highScore = 0;

const displayMessage = function (message) {
  document.querySelector('.message').textContent = message;
};
const displayScore = function (score) {
  document.querySelector('.score').textContent = score;
};
const setBGColor = function (color) {
  document.querySelector('body').style.backgroundColor = color;
};
const setNumberWidth = function (width) {
  document.querySelector('.number').style.width = width;
};
const setNumber = function (val) {
  document.querySelector('.number').textContent = val;
};

// Check number
document.querySelector('.check').addEventListener('click', function () {
  const guess = Number(document.querySelector('.guess').value);
  if (!guess) {
    displayMessage('🛑 No Number!');
  } else if (guess === secretNumber) {
    displayMessage('🔮 Correct Number!');
    setBGColor('#60b347');
    setNumberWidth('30rem');
    setNumber(secretNumber);
    if (score > highScore) {
      highScore = score;
      document.querySelector('.highscore').textContent = highScore;
    }
  } else if (guess !== secretNumber) {
    if (score > 1) {
      displayMessage(guess > secretNumber ? '⤴️ Too High!' : '⤵️ Too Low!');
      score--;
      displayScore(score);
    } else {
      displayMessage('💥 GAME OVER!');
      displayScore(0);
    }
  }
});

//reset
document.querySelector('.again').addEventListener('click', function () {
  score = 20;
  secretNumber = Math.trunc(Math.random() * 20) + 1;
  displayScore(score);
  setNumber('?');
  displayMessage('Start guessing...');
  document.querySelector('.guess').value = 'Reset Form';
  setBGColor('#222');
  setNumberWidth('15rem');
});
